import dbSwitch from "@/services/dbSwitch";

// Admin DB switch (QA / staging only): a system admin moves the whole app to another database.
// While it runs every API call answers 503 MAINTENANCE; afterwards every older token answers
// 401 DB_SWITCHED. helpers/interceptors.js routes both here, as does the tf-frontend sub-app over
// qiankun/hostBridge.js.

export const DB_SWITCHED_NOTICE_KEY = "dbSwitchedNotice";
const DB_SWITCHED_NOTICE =
  "The system was switched to another database. Please log in again.";

// A burst of parallel 401 DB_SWITCHED answers ends the session once; the redirect reloads the page.
let sessionEnding = false;

const getDefaultState = () => {
  return {
    maintenance: false,
    // This admin started the switch: their own page shows its progress / result, so the overlay
    // and the automatic logout stay out of the way until they press "Log in again".
    ownSwitchRunning: false,
    // GET /admin/db-switch answered 200: this admin may switch on this environment.
    available: false,
    status: null,
  };
};

const state = getDefaultState();

const getters = {
  isDbSwitchMaintenance: (state) => state.maintenance,
  isOwnDbSwitchRunning: (state) => state.ownSwitchRunning,
  isDbSwitchAvailable: (state) => state.available,
  getDbSwitchStatus: (state) => state.status,
};

const mutations = {
  ["SET_DB_SWITCH_MAINTENANCE"](state, data) {
    state.maintenance = data;
  },
  ["SET_OWN_DB_SWITCH_RUNNING"](state, data) {
    state.ownSwitchRunning = data;
  },
  ["SET_DB_SWITCH_AVAILABLE"](state, data) {
    state.available = data;
  },
  ["SET_DB_SWITCH_STATUS"](state, data) {
    state.status = data;
  },
};

const actions = {
  fetchDbSwitchStatus: ({ commit }) => {
    return dbSwitch.getStatus().then((res) => {
      commit("SET_DB_SWITCH_STATUS", res.data);
      commit("SET_DB_SWITCH_AVAILABLE", true);
      return res;
    });
  },
  // Quietly works out whether to show the menu entry: 403 NOT_ALLOWED (not a named admin) and
  // 404 DB_SWITCH_DISABLED (production) both just mean no.
  checkDbSwitchAvailable: ({ commit, dispatch }) => {
    return dispatch("fetchDbSwitchStatus").catch(() => {
      commit("SET_DB_SWITCH_AVAILABLE", false);
    });
  },
  switchDatabase: (_, database) => {
    return dbSwitch.switchDatabase(database);
  },
  setOwnDbSwitchRunning: ({ commit }, payload) => {
    commit("SET_OWN_DB_SWITCH_RUNNING", payload);
  },
  startDbSwitchMaintenance: ({ state, commit }) => {
    if (state.ownSwitchRunning) return;
    commit("SET_DB_SWITCH_MAINTENANCE", true);
  },
  endDbSwitchMaintenance: ({ commit }) => {
    commit("SET_DB_SWITCH_MAINTENANCE", false);
  },
  // forceLogout, not logout: logout calls the server first, which would only get the same 401.
  // The notice survives forceLogout's full-page redirect in sessionStorage; App.vue shows it.
  dbSwitchedLogout: ({ dispatch }) => {
    if (sessionEnding) return;
    sessionEnding = true;
    sessionStorage.setItem(DB_SWITCHED_NOTICE_KEY, DB_SWITCHED_NOTICE);
    dispatch("forceLogout");
  },
};

export default { state, getters, mutations, actions };
